{
  "name": "v2x-ui",
  "version": "2.9.0",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://sinelec.visualstudio.com/EMERAS/_git/v2x-smart-road-console"
  },
  "scripts": {
    "start": "parcel src/index.html",
    "build": "parcel build src/index.html",
    "eslint-check-ts": "eslint \"**/*.ts\" --ignore-pattern node_modules/",
    "eslint-check-tsx": "eslint \"**/*.tsx\" --ignore-pattern node_modules/",
    "eslint-fix-ts": "eslint \"**/*.ts\" --ignore-pattern node_modules/ --fix",
    "eslint-fix-tsx": "eslint \"**/*.tsx\" --ignore-pattern node_modules/ --fix",
    "generate-pictograms-icons-index": "node ./generateIndex.js",
    "generate-denm-icons-base64": "node ./scripts/generateDenmIconsBase64.js",
    "generate-ivim-icons-base64": "node ./scripts/generateIvimIconsBase64.js",
    "generate-icons-base64": "npm run generate-denm-icons-base64 && npm run generate-ivim-icons-base64",
    "clean": "rm -rf .parcel-cache dist",
    "bump": "commit-and-tag-version"
  },
  "dependencies": {
    "@date-io/date-fns": "1.x",
    "@faker-js/faker": "^9.5.0",
    "@fluent/bundle": "^0.17.0",
    "@fluent/langneg": "^0.6.0",
    "@fluent/react": "^0.14.0",
    "@fortawesome/fontawesome-svg-core": "^6.5.1",
    "@fortawesome/free-regular-svg-icons": "^6.5.1",
    "@fortawesome/free-solid-svg-icons": "^6.5.1",
    "@fortawesome/react-fontawesome": "^0.2.0",
    "@material-ui/core": "^4.11.3",
    "@material-ui/icons": "^4.11.2",
    "@material-ui/lab": "^4.0.0-alpha.57",
    "@material-ui/pickers": "^3.2.10",
    "@parcel/transformer-raw": "^2.0.0-alpha.3",
    "@reach/router": "^1.3.4",
    "@reduxjs/toolkit": "^1.5.0",
    "@turf/turf": "^7.0.0",
    "@types/leaflet": "^1.7.5",
    "@types/leaflet.heat": "^0.2.0",
    "@types/node": "^14.14.31",
    "@types/reach__router": "^1.3.7",
    "@types/react": "^17.0.2",
    "@types/react-dom": "^17.0.1",
    "@types/react-leaflet-markercluster": "^3.0.0",
    "@types/react-redux": "^7.1.16",
    "@types/redux-saga": "^0.10.5",
    "chart.js": "^4.4.8",
    "clsx": "^1.1.1",
    "date-fns": "^2.19.0",
    "leaflet": "^1.7.1",
    "leaflet.heat": "^0.2.0",
    "leaflet.markercluster": "^1.5.1",
    "lodash": "^4.17.21",
    "oidc-client-ts": "^2.4.0",
    "parcel": "2.0.0-beta.2",
    "react": "^17.0.1",
    "react-chartjs-2": "^5.3.0",
    "react-dom": "^17.0.1",
    "react-leaflet": "^3.2.1",
    "react-leaflet-google-layer": "^2.0.4",
    "react-leaflet-markercluster": "^3.0.0-rc1",
    "react-oidc-context": "^2.3.1",
    "react-papaparse": "^4.4.0",
    "react-redux": "^7.2.2",
    "recharts": "^2.0.9",
    "redux-devtools-extension": "^2.13.8",
    "redux-saga": "^1.1.3",
    "redux-toolkit-saga": "^1.2.0",
    "tslib": "^2.3.1",
    "typed-redux-saga": "^1.3.1",
    "typescript": "^4.4.3",
    "update-browserslist-db": "^1.0.13"
  },
  "devDependencies": {
    "@parcel/transformer-image": "2.0.0-beta.2",
    "@parcel/transformer-sass": "2.0.0-beta.2",
    "@types/faker": "^6.6.11",
    "@typescript-eslint/eslint-plugin": "^4.33.0",
    "@typescript-eslint/parser": "^4.33.0",
    "autoprefixer": "^10.2.4",
    "commit-and-tag-version": "11.3.0",
    "eslint": "^7.20.0",
    "eslint-config-airbnb-base": "^14.2.1",
    "eslint-config-prettier": "^8.0.0",
    "eslint-import-resolver-typescript": "^2.4.0",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-prettier": "^3.3.1",
    "eslint-plugin-simple-import-sort": "^7.0.0",
    "postcss": "^8.1.0",
    "rimraf": "^3.0.2",
    "sass": "^1.32.8"
  },
  "resolutions": {
    "@react-leaflet/core": "1.1.1"
  },
  "alias": {
    "_lib": "./src/lib",
    "_store": "./src/store"
  }
}
